import React from 'react';
import './PhasePage.css';

const FeatureSection: React.FC = () => {
  const features = [
    {
      title: (
        <>
          <span className="highlight-text">AI-Powered Coaching</span>
        </>
      ),
      description: "Your personal AI fitness trainer that creates personalized workout plans tailored to your goals. Track your progress, get adaptive coaching that evolves with you, and receive accountability guidance that keeps you motivated throughout your fitness journey.",
      image: require('../../assets/images/phone-1.png'),
      layout: 'image-left'
    },
    {
      title: (
        <>
          <span className="highlight-text">Smart Nutrition Logging</span>
        </>
      ),
      description: "Revolutionary photo-based nutrition tracking. Simply snap a photo of your meal and our AI analyzes it for precise macro tracking. Get instant feedback on your meals and simplify your nutrition journey with cutting-edge image recognition technology.",
      image: require('../../assets/images/phone-2.png'),
      layout: 'image-right'
    },
    {
      title: (
        <>
          <span className="highlight-text">Progress Tracking</span>
        </>
      ),
      description: "Monitor your fitness journey with comprehensive progress tracking. See your improvements over time, track consistency, and get insights that help you stay motivated. Your AI coach adapts plans based on your progress and keeps you accountable.",
      image: require('../../assets/images/phone-3.png'),
      layout: 'image-left'
    },
    {
      title: (
        <>
          <span className="highlight-text">Adaptive Plans</span>
        </>
      ),
      description: "Workout plans that evolve with you. As you progress, your AI trainer adjusts intensity, volume, and exercises to match your current fitness level. No more static programs—get plans that grow with your capabilities and goals.",
      image: require('../../assets/images/phone-1.png'),
      layout: 'image-right'
    }
  ];

  return (
    <section className="feature-section">
      <div className="features-container">
        {features.map((feature, index) => (
          <div 
            key={index} 
            className={`feature-card ${feature.layout}`}
          >
            <div className="feature-content">
              <h2 className="feature-title">{feature.title}</h2>
              <p className="feature-description">{feature.description}</p>
            </div>
            <div className="feature-image-wrapper">
              <img 
                src={feature.image} 
                alt="Phase App Feature" 
                className="feature-image"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeatureSection;